export default __webpack_public_path__ + "chevron-down.3a6d53af.svg";